// The secret declarations editor's helpers (spec 6.10.13).
import type { SecretDeclaration } from '../api/types';

/** DOM id of a declaration's input (diagnostics at `/secrets/<name>` focus the name). */
export function declarationInputId(name: string, field: string) {
  return `secret-${name}-${field}`;
}

/** Edits of the open blueprint's `secrets` (spec 6.10.13); each is one undo step of the designer. */
export interface DeclarationsEditing {
  /** Replaces one declaration; edits with the same coalesce key merge into one undo step. */
  change(name: string, declaration: SecretDeclaration, coalesceKey?: string): void;
  /** Adds `secret-<n>` and returns its name. */
  add(): string;
  /** Renames a declaration and every `${secret.<old>}` reference. */
  rename(oldName: string, newName: string): void;
  remove(name: string): void;
}

/** The lowest free `secret-<n>` (spec 6.10.13). */
export function nextSecretName(names: readonly string[]): string {
  const taken = new Set(names.map((n) => n.toLowerCase()));
  let n = 1;
  while (taken.has(`secret-${n}`)) n++;
  return `secret-${n}`;
}
